import React, { FunctionComponent } from "react";
import cx from "classnames";
interface Props {
	children?: React.ReactNode;
	open: boolean;
}

const ClubSidebar: FunctionComponent<Props> = ({ children, open = false }: Props) => {
	const className = cx("sidebar", { open });
	return <div className={className}>{children}</div>;
};

export default ClubSidebar;
